import { Filter } from '@/interfaces/filter.interface'
import { APIBulkUnsubscription } from '@/models/api/bulk-unsubscription.model'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { BulkUnsubscriptionServices } from '../../services/modules/bulk-unsubscription.service'
// import { APIBulkUnsubscription } from '../../models/api/bulk-unsubscription.model'

@Module
export default class BulkUnsubscriptionStore extends VuexModule {
    bulkUnsubscriptions: object[] = [];
    bulkUnsubscriptionsPaginate: object[] = [];
    bulkUnsubscriptionForm: object | null = null;

    @Mutation
    updateBulkUnsubscriptions (newData: object[]) {
        this.bulkUnsubscriptions = newData
    }

    @Mutation
    updateBulkUnsubscriptionsPaginate (newData: object[]) {
        this.bulkUnsubscriptionsPaginate = newData
    }

    @Mutation
    updateBulkUnsubscription (newData: object) {
        this.bulkUnsubscriptionForm = newData
    }

    @Action
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    createBulkUnsubscriptionPending (params: any) {
        return new Promise(resolve => {
            if (!params) {
                store.commit('reportError', {
                    code: 1000,
                    statement: 'Something went wrong :('
                })
                resolve()
                return
            }
            const data = Object.assign({}, params)
            BulkUnsubscriptionServices.createBulkUnsubscriptionPending(data)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createBulkUnsubscription (params: APIBulkUnsubscription) {
        return new Promise((resolve) => {
            if (!params) {
                store.commit('reportError', { code: 1000, statement: 'Something went wrong :(' })
                resolve()
                return
            }
            const data = Object.assign({}, params)
            BulkUnsubscriptionServices.createBulkUnsubscriptions(data)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editBulkUnsubscription (dataForm: {id: number; params: APIBulkUnsubscription}) {
        return new Promise((resolve) => {
            if (!dataForm.params) {
                store.commit('reportError', { code: 1000, statement: 'Something went wrong :(' })
                resolve()
                return
            }

            const data = Object.assign({}, dataForm.params)
            BulkUnsubscriptionServices.editBulkUnsubscriptions(dataForm.id, data)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getBulkUnsubscriptionPaginate (params: {
        page: number;
        filters?: Filter[];
        limit: number;
        providerId?: number;
        carrierId?: number;
        sortBy: string;
        sort: string;
    }) {
        return new Promise(resolve => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: { [key: string]: any } = {
                page: params.page,
                limit: params.limit,
                providerId: params.providerId,
                carrierId: params.carrierId,
                sortBy: params.sortBy,
                sort: params.sort
            }

            function getDateFormat (dateString: string) {
                if (!dateString) return null

                const date = new Date(dateString)
                date.setDate(date.getDate() + 1)

                const day = date
                    .getDate()
                    .toString()
                    .padStart(2, '0')
                const month = (date.getMonth() + 1).toString().padStart(2, '0')
                const year = date
                    .getFullYear()
                    .toString()
                    .padStart(4, '0')
                return `${year}-${month}-${day}`
            }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []
                            if (Array.isArray(newParams[filter.value])) {
                                helper = [...newParams[filter.value]]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') { helper.push(filter.queryValue) }

                            newParams[filter.value] = helper
                        }
                    }
                    if (filter.type === 'date') {
                        if (filter.queryValue) {
                            if (Array.isArray(filter.queryValue)) {
                                filter.queryValue = filter.queryValue.sort(
                                    (a: string, b: string) => {
                                        return (
                                            new Date(a + '-01').getTime() -
                                            new Date(b + '-01').getTime()
                                        )
                                    }
                                )
                            }

                            newParams[filter.value] = {
                                startDate: getDateFormat(
                                    filter.queryValue[0] || ''
                                ),
                                endDate: getDateFormat(
                                    filter.queryValue[1]
                                        ? filter.queryValue[1]
                                        : filter.queryValue[0] || ''
                                )
                            }
                        }
                    }
                })
            }
            BulkUnsubscriptionServices.getBulkUnsubscriptionsPaginate(
                newParams
            )
                .then(resp => {
                    store.commit(
                        'updateBulkUnsubscriptionsPaginate',
                        resp.data
                    )
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    // @Action
    // deleteStatements (id: number) {
    //     return new Promise((resolve) => {
    //         BulkUnsubscriptionServices.deleteStatements(id)
    //             .then(resp => {
    //                 resolve(resp)
    //             })
    //             .catch(error => {
    //                 resolve(error.response)
    //             })
    //     })
    // }

    // @Action
    // downloadStatementFile (id: number) {
    //     return new Promise((resolve) => {
    //         BulkUnsubscriptionServices.getStatementsFileById(id)
    //             .then(resp => {
    //                 resolve(resp)
    //             })
    //             .catch(error => {
    //                 resolve(error.response)
    //             })
    //     })
    // }
}
